module.exports = __webpack_public_path__ + "img/icon_form_select.770051e5.svg";